export class AssertionError extends Error {
  isAssertionFailed = true;
}

export default AssertionError;
